import { getMessageUnreadHandlerItems } from '_lib/utils/utilsFriend';
import EventBus from '_lib/EventBus';

export default {
  mounted() {
    EventBus.$on(
      'Not_Contact_Menu:contextmenu',
      this.notContactContextMenuHandler
    );
  },
  beforeDestroy() {
    EventBus.$off(
      'Not_Contact_Menu:contextmenu',
      this.notContactContextMenuHandler
    );
  },
  methods: {
    notContactContextMenuHandler(event, messageItem) {
      let groups = [
        {
          items: [...getMessageUnreadHandlerItems(messageItem)],
        },
      ];

      this.$contextmenu({
        event,
        groups,
      });
    },
  },
};
